module.exports = __webpack_public_path__ + "img/tendertrace_logo-white-pink-bars.e828a8a4.png";